<template>
  <div class="min-h-80 p-2 bg-gray-200 dark:bg-gray-900">
    <stationSelectModal :stations="stationList" :requestId="selectedRequestId" :request="selectedRequest" :hasLocation="stationHasLocation" @refresh="onStationDirected" />
    <requestHistoryModal :events="historyEvents" :loading="historyLoading" :receiptFileUrl="historyReceiptUrl" :isDeleted="historyIsDeleted" :requestItems="historyItems" @view-receipt="viewReceipt" />
    <requestDetailModal
      :item="detailItem"
      @refresh="getAll"
      @approve-item="approveItem"
      @reject-item="rejectItem"
      @view-receipt="viewReceipt"
      @open-edit="openEditModal"
      @open-cancel="openCancelModal"
      @correct-ocr="correctOcr"
      @ocr-error="(m) => swalBox('warning', 'Uyarı', m, false)"
    />

    <!-- Onay Modal -->
    <modal name="approve-modal" height="auto" width="440" :adaptive="true" :clickToClose="false">
      <div class="p-5" v-if="approveData.item">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-sm font-semibold">Yakıt Talebi Onayı</h3>
          <button class="text-gray-500 hover:text-gray-700" @click="$modal.hide('approve-modal')">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Talep Bilgileri -->
        <div class="bg-gray-50 rounded p-3 mb-3 space-y-1">
          <div class="flex justify-between text-xs">
            <span class="text-gray-500">Plaka</span>
            <span class="font-medium">{{ approveData.item.vehiclePlate }}</span>
          </div>
          <div class="flex justify-between text-xs">
            <span class="text-gray-500">Sürücü</span>
            <span class="font-medium">{{ approveData.item.driverName }}</span>
          </div>
          <div class="text-xs">
            <span class="text-gray-500 block mb-1">{{ approveRevise ? 'Kalem Kalem Onay Litreleri' : 'Talep Detayı' }}</span>
            <div v-for="(it, idx) in approveData.itemsView" :key="idx" class="flex items-center justify-between bg-white rounded px-2 py-1 mb-1">
              <span class="font-medium">{{ it.fuelType }}</span>
              <!-- Revize değilse: sade gösterim -->
              <template v-if="!approveRevise">
                <span v-if="it.isFillTank" class="px-1.5 py-0.5 text-white text-xxs rounded" style="background-color: #7c3aed;">TAM DOLUM</span>
                <span v-else class="font-semibold text-blue-600">{{ it.requestedLiters }} Lt</span>
              </template>
              <!-- Revize modu -->
              <template v-else>
                <div v-if="it.isFillTank" class="flex items-center space-x-2">
                  <span class="text-xxs text-gray-400">TAM DOLUM</span>
                  <input
                    v-model="it.reviseInput"
                    type="number"
                    min="0"
                    class="w-24 border border-gray-300 rounded px-2 py-0.5 text-xs text-right"
                    placeholder="boş = T.D."
                  />
                  <span class="text-xxs text-gray-500">Lt</span>
                </div>
                <div v-else class="flex items-center space-x-2">
                  <span class="text-xxs text-gray-400">Talep: {{ it.requestedLiters }} Lt</span>
                  <input
                    v-model.number="it.approvedLiters"
                    type="number"
                    min="0"
                    class="w-20 border border-gray-300 rounded px-2 py-0.5 text-xs text-right"
                  />
                  <span class="text-xxs text-gray-500">Lt</span>
                </div>
              </template>
            </div>
            <div v-if="!approveRevise && showTotalRow" class="flex justify-between border-t pt-1 mt-1">
              <span class="text-gray-500">Toplam Talep</span>
              <span class="font-semibold text-blue-600">{{ approveData.totalRequested }} Lt</span>
            </div>
            <div v-else-if="approveRevise && showTotalRow" class="flex justify-between border-t pt-1 mt-1">
              <span class="text-gray-500">Toplam Onay</span>
              <span class="font-semibold text-green-600">{{ totalApproved }} Lt</span>
            </div>
          </div>
          <div v-if="approveData.item.requestNote" class="text-xs pt-1 border-t">
            <span class="text-gray-500 block">Sürücü Notu:</span>
            <span class="font-medium italic">{{ approveData.item.requestNote }}</span>
          </div>
        </div>

        <!-- Butonlar -->
        <div class="flex space-x-2">
          <button class="flex-1 py-2 bg-green-500 text-white text-xs rounded hover:bg-green-600" @click="confirmApprove">
            <i class="fas fa-check mr-1"></i>{{ approveRevise ? 'Revize Onayla' : 'Onayla' }}
          </button>
          <button class="flex-1 py-2 bg-blue-500 text-white text-xs rounded hover:bg-blue-600" @click="approveRevise = !approveRevise">
            <i class="fas fa-edit mr-1"></i>{{ approveRevise ? 'Vazgeç' : 'Revize Et' }}
          </button>
          <button class="flex-1 py-2 bg-red-500 text-white text-xs rounded hover:bg-red-600" @click="$modal.hide('approve-modal')">
            <i class="fas fa-times mr-1"></i>İptal
          </button>
        </div>
      </div>
    </modal>

    <!-- Fiş Görüntüleme Modal -->
    <modal name="receipt-modal" height="auto" width="600" :adaptive="true" :clickToClose="true" :resizable="false">
      <div>
        <div class="flex items-center justify-between p-3 border-b">
          <h3 class="text-sm font-semibold">Yakıt Fişi</h3>
          <button class="text-gray-500 hover:text-gray-700" @click="closeReceiptModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <template v-if="receiptUrl">
          <div class="flex justify-end p-2 space-x-2 border-b bg-gray-50">
            <a :href="receiptUrl" target="_blank" rel="noopener" class="flex items-center px-3 py-1 text-xs text-white rounded" style="background-color: #3b82f6;">
              <i class="fas fa-external-link-alt mr-1"></i>Yeni Sekmede Aç
            </a>
            <a :href="receiptUrl" download target="_blank" class="flex items-center px-3 py-1 text-xs text-white rounded" style="background-color: #f97316;">
              <i class="fas fa-download mr-1"></i>Fişi İndir
            </a>
          </div>
          <div class="bg-gray-100 text-center" style="line-height: 0;">
            <div v-if="receiptImageError" class="p-4 text-center text-xs text-red-600 bg-red-50">
              <i class="fas fa-exclamation-triangle mr-1"></i>
              Resim yüklenemedi. URL'nin süresi dolmuş veya erişim engellenmiş olabilir.
            </div>
            <img
              v-else
              :src="receiptUrl"
              alt="Yakıt Fişi"
              style="max-width: 100%; max-height: 60vh; width: auto; height: auto; display: inline-block;"
              @error="onReceiptImageError"
              @load="receiptImageError = false"
            />
          </div>
        </template>
      </div>
    </modal>

    <!-- Düzenle Modal -->
    <editRequestModal :item="editItem" :stations="allStations" @refresh="getAll" />

    <!-- İptal Et Modal -->
    <cancelRequestModal :item="cancelItem" @cancelled="removeFromList" @refresh="getAll" />

    <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
      <!-- Tab -->
      <div class="flex border-b mb-3">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          class="px-4 py-2 text-sm font-medium flex items-center"
          :class="activeTab === tab.key ? 'border-b-2 border-red-500 text-red-600' : 'text-gray-500 hover:text-gray-700'"
          @click="switchTab(tab.key)"
        >
          <i v-if="tab.icon" :class="tab.icon" class="mr-1"></i>
          {{ tab.label }}
          <span v-if="activeTab === tab.key && totalCount > 0" class="ml-2 px-1.5 py-0.5 bg-red-500 text-white text-xxs rounded-full">{{ totalCount }}</span>
        </button>
      </div>

      <!-- Filtreler -->
      <div class="flex items-center space-x-3 mb-3 p-2">
        <div class="w-40">
          <diffInput v-model="filterStartDate" title="Başlangıç" type="date" />
        </div>
        <div class="w-40">
          <diffInput v-model="filterEndDate" title="Bitiş" type="date" />
        </div>
        <asyncBtn icon="fas fa-filter" text="Filtrele" class="w-28 btn mt-5" @click="getAll" />
      </div>

      <LyrausTable
        :key="activeTab"
        :data="List"
        :columns="columns"
        :enablePagination="true"
        :isLoading="load"
        :searchBar="true"
        :searchProp="search"
        @update-search-value="(val) => handleSearchValue(val)"
        :handleSearch="handleSearch"
        :pageCount="pageCount"
        :pageProp="currentPage"
        @update-current-page="handleCurrentPage"
        :totalCount="totalCount"
        :alternateRowBg="['white', 'gray-100']"
        :rightExtraSlot="true"
        :buttonsColumn="{ label: 'İşlem' }"
        :paginationButtonColor="'red-600'"
        :paginationHoverColor="'red-700'"
        :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
        :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
        :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
      >
        <template v-slot:searchBar>
          <SearchInput :value="search" :isFull="true" @searcing="(val) => { handleSearchValue(val); handleSearch(); }" />
        </template>

        <!-- Sıralanabilir sütun başlığı için ok ikonu -->
        <template v-slot:sortButton="{ columnKey }">
          <button v-if="sortableKeys.includes(columnKey)" class="text-gray-400 hover:text-gray-700" @click="toggleSort(columnKey)">
            <i v-if="sortBy === columnKey && sortDir === 'asc'" class="fas fa-arrow-up text-xxs"></i>
            <i v-else-if="sortBy === columnKey && sortDir === 'desc'" class="fas fa-arrow-down text-xxs"></i>
            <i v-else class="fas fa-sort text-xxs opacity-50"></i>
          </button>
        </template>

        <!-- Özel hücreler: items özetli, requestNote truncate, vs. -->
        <template v-slot:rowButtons="{ item, columnKey }">
          <span v-if="columnKey === 'itemsSummary'" class="text-xxs">
            <span v-for="(it, idx) in (item.items || [])" :key="idx" class="inline-block mr-2">
              <span class="font-medium">{{ it.fuelType }}</span>: <span>{{ itemSummaryDisplay(it) }}</span>
              <span v-if="it.itemStatus === 1" class="ml-1" title="Onay Bekliyor">🟡</span>
              <span v-else-if="it.itemStatus === 7" class="ml-1" title="Reddedildi">🔴</span>
            </span>
            <span v-if="pendingItemCount(item) > 0" class="inline-block px-1.5 py-0.5 text-xxs font-bold text-white rounded animate-pulse" style="background-color: #f59e0b;" :title="`${pendingItemCount(item)} kalem onay bekliyor`">
              <i class="fas fa-exclamation mr-1"></i>{{ pendingItemCount(item) }} Yeni Kalem
            </span>
          </span>
          <span v-else-if="columnKey === 'requestNote'" class="text-xxs italic text-gray-600" :title="item.requestNote">
            {{ item.requestNote ? (item.requestNote.length > 30 ? item.requestNote.substring(0, 30) + '...' : item.requestNote) : '—' }}
          </span>
          <span v-else-if="columnKey === 'rejectionReason'" class="flex items-center text-xs text-gray-800">
            <i class="fas fa-info-circle mr-1 text-red-500"></i>
            <span class="font-medium">{{ rejectionReasonShort(item) }}</span>
            <button
              v-if="isRejectionReasonLong(item)"
              class="ml-2 px-2 py-0.5 text-xxs font-semibold text-red-700 bg-red-50 hover:bg-red-100 border border-red-200 rounded"
              @click.stop="showRejectionDetail(item)"
            >
              Tümünü Göster
            </button>
          </span>
        </template>

        <template v-slot:colButtons="{ item }">
          <div class="flex items-center justify-end space-x-1 px-2">
            <button
              class="px-2 py-1 text-white text-xxs rounded"
              :style="{ backgroundColor: pendingItemCount(item) > 0 ? '#f59e0b' : '#6b7280' }"
              :class="{ 'ring-2 ring-yellow-400 ring-offset-1 animate-pulse': pendingItemCount(item) > 0 }"
              @click="showDetail(item)"
              :title="pendingItemCount(item) > 0 ? `${pendingItemCount(item)} kalem onay bekliyor` : 'İşlem'"
            >
              <i class="fas fa-tasks mr-1"></i>İşlem
              <span v-if="pendingItemCount(item) > 0" class="ml-1 font-bold">{{ pendingItemCount(item) }}</span>
            </button>
            <button class="px-2 py-1 text-white text-xxs rounded" style="background-color: #9ca3af;" @click="showHistory(item)" title="Geçmiş">
              <i class="fas fa-history mr-1"></i>Geçmiş
            </button>
            <template v-if="activeTab === 'active'">
              <button v-if="Number(item.status) === 2 && !item.stationName && !hasPendingItems(item)" class="px-2 py-1 bg-blue-500 text-white text-xxs rounded" @click="showStationModal(item)">
                <i class="fas fa-gas-pump mr-1"></i>İstasyon Seç
              </button>
              <button v-if="item.receiptFileUrl" class="px-2 py-1 text-white text-xxs rounded" style="background-color: #f97316;" @click="viewReceipt(item.receiptFileUrl, item.id)">
                <i class="fas fa-receipt mr-1"></i>Fiş
              </button>
            </template>
          </div>
        </template>
      </LyrausTable>
    </div>
  </div>
</template>

<script>
import asyncBtn from "@/components/general/asyncBtn.vue";
import diffInput from "@/components/general/diffInput.vue";
import SearchInput from "@/components/general/search-input.vue";
import axios from "axios";
import moment from "moment";
import "moment/locale/tr";
import { fuel } from "@/networking/urlmanager";
import stationSelectModal from "./components/stationSelect.modal.vue";
import requestHistoryModal from "./components/requestHistory.modal.vue";
import requestDetailModal from "./components/requestDetail.modal.vue";
import editRequestModal from "./components/editRequest.modal.vue";
import cancelRequestModal from "./components/cancelRequest.modal.vue";
import fuelStream from "@/services/fuelEventStream";

export default {
  name: "fuel-requests-module",
  components: { asyncBtn, diffInput, SearchInput, stationSelectModal, requestHistoryModal, requestDetailModal, editRequestModal, cancelRequestModal },
  data() {
    return {
      load: false,
      search: "",
      activeTab: "active",
      tabs: [
        { key: "active", label: "Aktif Talepler" },
        { key: "completed", label: "Tamamlanan Talepler" },
        { key: "rejected", label: "Reddedilen Talepler" },
      ],
      List: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      filterStartDate: "",
      filterEndDate: "",
      sortBy: "addDate",
      sortDir: "desc",
      sortableKeys: ["addDate", "vehiclePlate", "driverName", "status"],
      selectedRequestId: null,
      selectedRequest: null,
      stationList: [],
      stationHasLocation: true,
      allStations: [],
      receiptUrl: "",
      receiptImageError: false,
      receiptRetried: false,
      receiptRequestId: null,
      approveData: { item: null, items: [], itemsView: [], totalRequested: 0 },
      approveRevise: false,
      approveRevisedLiters: 0,
      historyEvents: [],
      historyLoading: false,
      historyReceiptUrl: "",
      historyIsDeleted: false,
      historyItems: [],
      detailItem: null,
      editItem: null,
      cancelItem: null,
      sseStatus: "disconnected",
      sseUnsubs: [],
      baseColumns: [
        { key: "vehiclePlate", label: "Plaka" },
        { key: "driverName", label: "Sürücü" },
        { key: "itemsSummary", label: "Kalemler", dontDisplay: true },
        { key: "stationName", label: "İstasyon" },
        { key: "requestNote", label: "Not", dontDisplay: true },
        { key: "statusText", label: "Durum" },
        { key: "addDate", label: "Tarih", isDate: true },
      ],
    };
  },
  computed: {
    columns() {
      if (this.activeTab === "rejected") {
        // Reddedilenlerde "Red Nedeni" kolonu ekle (istasyon kolonu yerine)
        return [
          { key: "vehiclePlate", label: "Plaka" },
          { key: "driverName", label: "Sürücü" },
          { key: "itemsSummary", label: "Kalemler", dontDisplay: true },
          { key: "rejectionReason", label: "Red Nedeni", dontDisplay: true },
          { key: "statusText", label: "Durum" },
          { key: "addDate", label: "Tarih", isDate: true },
        ];
      }
      return this.baseColumns;
    },
    totalApproved() {
      return (this.approveData.itemsView || []).reduce((sum, it) => {
        if (it.isFillTank) {
          const limit = it.reviseInput === "" || it.reviseInput == null ? 0 : Number(it.reviseInput);
          return sum + limit;
        }
        return sum + Number(it.approvedLiters || 0);
      }, 0);
    },
    showTotalRow() {
      // Tek kalem varsa veya tüm kalemler arasında TAM DOLUM varsa toplam göstermenin anlamı yok
      const items = this.approveData.itemsView || [];
      if (items.length <= 1) return false;
      if (items.some(it => it.isFillTank)) return false;
      return true;
    },
  },
  methods: {
    getStatusText(status) {
      // 5 = fiş alındı, OCR arkada çalışıyor. Bu durum normalde saniyeler
      // sürer; uzun süre burada kalan talep OCR'ın takıldığını gösterir.
      const map = { 1: "Beklemede", 2: "Onaylandı", 3: "Yönlendirildi", 4: "Yakıt Alındı", 5: "Fiş İşleniyor", 6: "Tamamlandı", 7: "Reddedildi", 8: "Silindi" };
      return map[status] || status;
    },
    pendingItemCount(item) {
      return (item.items || []).filter(it => it.itemStatus === 1).length;
    },
    hasPendingItems(item) {
      return this.pendingItemCount(item) > 0;
    },
    enrichItem(item) {
      const statusText = item.statusLabel || this.getStatusText(item.status);
      return { ...item, statusText };
    },
    rejectionReasonFull(item) {
      // Talep seviyesinde — backend farklı adlarda gönderebiliyor
      const reqReason = item.rejectionReason || item.cancelReason || item.reason;
      if (reqReason) return reqReason;
      // Kalem seviyesinde — items[] içinde reddedilenler
      const itemReasons = (item.items || [])
        .filter(it => it.itemStatus === 7)
        .map(it => {
          const r = it.rejectionReason || it.cancelReason || it.reason;
          return r ? `${it.fuelType}: ${r}` : null;
        })
        .filter(Boolean);
      return itemReasons.length > 0 ? itemReasons.join(" | ") : "—";
    },
    rejectionReasonShort(item) {
      const full = this.rejectionReasonFull(item);
      if (full === "—") return "—";
      return full.length > 30 ? full.substring(0, 30) + "..." : full;
    },
    isRejectionReasonLong(item) {
      const full = this.rejectionReasonFull(item);
      return full !== "—" && full.length > 30;
    },
    showRejectionDetail(item) {
      const full = this.rejectionReasonFull(item);
      const plate = item.vehiclePlate || "";
      const rawDate = item.rejectedDate || item.editDate || "";
      const date = rawDate ? moment.utc(rawDate).format("LLL") : "";
      this.$swal.fire({
        icon: "error",
        title: "Red Nedeni",
        html: `
          <div style="text-align:left;">
            ${plate ? `<div style='font-size:12px;color:#6b7280;margin-bottom:4px;'><b>Plaka:</b> ${plate}</div>` : ""}
            ${date ? `<div style='font-size:12px;color:#6b7280;margin-bottom:12px;'><b>Tarih:</b> ${date}</div>` : ""}
            <div style="background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:12px;color:#7f1d1d;font-size:13px;line-height:1.5;white-space:pre-wrap;word-break:break-word;">
              ${this.escapeHtml(full)}
            </div>
          </div>
        `,
        confirmButtonText: "Kapat",
        confirmButtonColor: "#6b7280",
      });
    },
    escapeHtml(str) {
      if (str == null) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    itemSummaryDisplay(it) {
      // Onay bekliyor / Reddedildi → sürücünün talebini göster
      if (it.itemStatus === 1 || it.itemStatus === 7) {
        if (it.isFillTank) return "TAM DOLUM";
        return (it.requestedLiters || 0) + " Lt";
      }
      // Onaylandı (veya sonrası)
      if (it.approvedLiters != null) return it.approvedLiters + " Lt";
      if (it.isFillTank) return "TAM DOLUM";
      return "—";
    },
    checkPendingNotificationOpen() {
      const reqId = sessionStorage.getItem("openFuelRequestId");
      if (reqId) {
        sessionStorage.removeItem("openFuelRequestId");
        // Liste yüklendikten sonra detay aç
        const tryOpen = () => {
          if (this.List.length > 0) {
            this.openDetailById(Number(reqId));
          } else {
            setTimeout(tryOpen, 300);
          }
        };
        setTimeout(tryOpen, 300);
      }
    },
    openDetailById(requestId) {
      const item = this.List.find(r => r.id === requestId);
      if (item) {
        this.showDetail(item);
      } else {
        // Liste içinde yoksa, doğrudan getAll yapıp tekrar dene (farklı sekmede olabilir)
        this.swalBox("info", "Bildirim", `Talep #${requestId} aktif listede bulunamadı. Diğer sekmelerde olabilir.`, false);
      }
    },
    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      this.currentPage = 0;
      this.getAll();
    },
    toggleSort(key) {
      if (this.sortBy === key) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortBy = key;
        this.sortDir = "asc";
      }
      this.getAll();
    },
    handleSearch() { this.currentPage = 0; this.getAll(); },
    handleCurrentPage(val) { this.currentPage = val; },
    handleSearchValue(val) { this.search = val; this.getAll(true); },
    getAll(isSearch = false) {
      if (isSearch) this.currentPage = 0;
      this.List = [];
      this.load = true;
      let url = fuel.requestGetAll + "?page=" + this.currentPage + "&search=" + this.search;
      url += "&statusGroup=" + this.activeTab;
      url += "&sortBy=" + this.sortBy + "&sortDir=" + this.sortDir;
      if (this.filterStartDate) url += "&startDate=" + this.filterStartDate;
      if (this.filterEndDate) url += "&endDate=" + this.filterEndDate;

      return axios.get(url, { headers: { Authorization: "Bareer " + this.$store.state.userData.token } })
        .then((res) => {
          const data = res.data.data || {};
          this.List = (data.detail || []).map(item => this.enrichItem(item));
          this.totalCount = data.totalCount || 0;
          this.pageCount = data.pageCount || 1;
        })
        .catch((err) => { this.handleApiError(err); })
        .finally(() => { this.load = false; });
    },
    handleApiError(err) {
      const msg = err.response?.data?.message;
      if (err.response?.status === 400 && msg && msg.includes("yetki")) {
        this.swalBox("warning", "Yetki Hatası", msg, false);
      } else {
        this.errorBox(err.response);
      }
    },
    // === ONAYLAMA AKIŞI ===
    approveRequest(item) {
      // Items varsa kullan, yoksa eski format için tek sahte item üret
      const rawItems = (item.items && item.items.length > 0)
        ? item.items
        : [{
            id: null,
            fuelType: item.requestedFuelType || "—",
            requestedLiters: item.requestedLiters || 0,
            isFillTank: false,
          }];

      const itemsView = rawItems.map(it => ({
        itemId: it.id,
        fuelType: it.fuelType,
        requestedLiters: Number(it.requestedLiters || 0),
        isFillTank: !!it.isFillTank,
        approvedLiters: Number(it.requestedLiters || 0),
        reviseInput: "", // TAM DOLUM revize için: boş → TAM DOLUM, sayı → limit litre
      }));

      const totalRequested = itemsView.reduce((sum, it) => sum + (it.isFillTank ? 0 : Number(it.requestedLiters || 0)), 0);

      this.approveData = {
        item,
        items: itemsView,
        itemsView,
        totalRequested,
      };
      this.approveRevise = false;
      this.approveRevisedLiters = totalRequested;
      this.$modal.show("approve-modal");
    },
    confirmApprove() {
      const body = { requestId: this.approveData.item.id };
      const itemsView = this.approveData.itemsView;
      const itemsWithIds = itemsView.filter(it => it.itemId);

      if (this.approveRevise) {
        // Revize: her kalem için
        //  - TAM DOLUM kalemi: reviseInput boşsa TAM DOLUM (null), sayı varsa o limit
        //  - Normal kalem: approvedLiters olarak gönder
        const invalid = itemsView.find(it => {
          if (it.isFillTank) {
            // TAM DOLUM için input boş olabilir (TAM DOLUM onaylama) ya da pozitif sayı
            if (it.reviseInput === "" || it.reviseInput == null) return false;
            return Number(it.reviseInput) <= 0;
          }
          return Number(it.approvedLiters) <= 0 || it.approvedLiters == null || it.approvedLiters === "";
        });
        if (invalid) {
          this.swalBox("warning", "Uyarı", `${invalid.fuelType} kalemi için geçerli bir litre değeri giriniz.`, false);
          return;
        }
        if (itemsWithIds.length > 0) {
          body.items = itemsWithIds.map(it => {
            if (it.isFillTank) {
              const limit = it.reviseInput === "" || it.reviseInput == null ? null : Number(it.reviseInput);
              return { itemId: it.itemId, approvedLiters: limit };
            }
            return { itemId: it.itemId, approvedLiters: Number(it.approvedLiters) };
          });
        }
      } else {
        // Direkt onay: items varsa her item kendi requestedLiters'ı ile onaylansın
        if (itemsWithIds.length > 0) {
          body.items = itemsWithIds.map(it => ({
            itemId: it.itemId,
            approvedLiters: it.isFillTank ? null : (it.requestedLiters || 0),
          }));
        }
      }

      axios.post(fuel.requestApprove, body, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          const approvedItem = this.approveData.item;
          this.$modal.hide("approve-modal");
          return this.getAll().then(() => approvedItem);
        })
        .then((approvedItem) => {
          if (approvedItem) this.showStationModal(approvedItem);
        })
        .catch((err) => { this.handleApiError(err); });
    },
    rejectRequest(item) {
      this.swalBox("warning", "Talep Reddi", "Red nedenini giriniz:", true, "Reddet", "İptal", true)
        .then((acc) => {
          if (acc.isConfirmed) {
            axios.post(fuel.requestReject, { requestId: item.id, rejectionReason: acc.value || "" }, {
              headers: { Authorization: "Bareer " + this.$store.state.userData.token },
            })
              .then(() => { this.swalBox("success", "Reddedildi", "", false); this.getAll(); })
              .catch((err) => { this.handleApiError(err); });
          }
        });
    },
    // === ITEM (Sonradan Eklenen Kalem) ONAY/RED ===
    approveItem({ requestId, itemId, approvedLiters }) {
      // Talep status=1 ise: bu kalem en son kalansa /request/approve (talebi onayla), değilse /item/approve (kalemi onayla, talep beklemede kalsın)
      // Talep status>=2 ise: her zaman /item/approve
      const detail = this.detailItem;
      const isPendingRequest = detail && detail.id === requestId && detail.status === 1;
      let promoteToApproved = false;

      if (isPendingRequest) {
        const pendingOthers = (detail.items || []).filter(it => it.itemStatus === 1 && it.id !== itemId);
        promoteToApproved = pendingOthers.length === 0; // bu kalem onaylanırsa hiç bekleyen kalmıyor
      }

      const endpoint = promoteToApproved ? fuel.requestApprove : fuel.requestItemApprove;
      const body = promoteToApproved
        ? { requestId, items: [{ itemId, approvedLiters }] }
        : { requestId, itemId, approvedLiters };

      axios.post(endpoint, body, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          // Optimistic update: detay modal'daki kalemi anında güncelle
          this.patchDetailItem(requestId, itemId, { itemStatus: 2, approvedLiters });
          if (promoteToApproved && this.detailItem && this.detailItem.id === requestId) {
            this.detailItem = { ...this.detailItem, status: 2, statusText: this.getStatusText(2) };
          }
          this.swalBox("success", promoteToApproved ? "Talep ve Kalem Onaylandı" : "Kalem Onaylandı", "", false);
          return this.getAll();
        })
        .then(() => {
          this.refreshDetail(requestId);
          // Talep yeni onaylandıysa: detay modali kapat ve istasyon seçim modali aç
          if (promoteToApproved) {
            this.$modal.hide("request-detail-modal");
            const updated = this.List.find(r => r.id === requestId);
            if (updated) this.showStationModal(updated);
          }
        })
        .catch((err) => { this.handleApiError(err); });
    },
    rejectItem({ requestId, itemId, rejectionReason }) {
      axios.post(fuel.requestItemReject, { requestId, itemId, rejectionReason }, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          this.patchDetailItem(requestId, itemId, { itemStatus: 7, rejectionReason });
          this.swalBox("success", "Kalem Reddedildi", "", false);
          return this.getAll();
        })
        .then(() => { this.refreshDetail(requestId); })
        .catch((err) => { this.handleApiError(err); });
    },
    patchDetailItem(requestId, itemId, patch) {
      if (!this.detailItem || this.detailItem.id !== requestId) return;
      const items = (this.detailItem.items || []).map(it =>
        it.id === itemId ? { ...it, ...patch } : it
      );
      this.detailItem = { ...this.detailItem, items };
    },
    refreshDetail(requestId) {
      // Detay modal açıksa, mevcut item'ı güncel veriyle yenile
      const updated = this.List.find(r => r.id === requestId);
      if (updated && this.detailItem && this.detailItem.id === requestId) {
        this.detailItem = updated;
      }
    },
    showHistory(item) {
      this.historyEvents = [];
      this.historyReceiptUrl = item.receiptFileUrl || "";
      this.historyIsDeleted = false;
      this.historyItems = item.items || [];
      this.historyLoading = true;
      this.$modal.show("request-history-modal");
      axios.get(fuel.requestHistory + "?requestId=" + item.id, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then((res) => {
          const data = res.data.data || {};
          this.historyEvents = data.timeline || [];
          this.historyIsDeleted = data.isDeleted === true;
        })
        .catch((err) => { this.handleApiError(err); this.$modal.hide("request-history-modal"); })
        .finally(() => { this.historyLoading = false; });
    },
    showStationModal(item) {
      this.selectedRequestId = item.id;
      this.selectedRequest = item;
      this.stationList = [];
      this.stationHasLocation = true;
      axios.get(fuel.stationNearestByRequest + "?requestId=" + item.id, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then((res) => {
          const data = res.data.data || {};
          this.stationList = data.stations || [];
          this.stationHasLocation = data.hasLocation !== false;
          this.$modal.show("station-select-modal");
        })
        .catch((err) => { this.handleApiError(err); });
    },
    onStationDirected() {
      this.$modal.hide("station-select-modal");
      this.getAll();
    },
    viewReceipt(fileUrl, requestId) {
      if (!fileUrl) {
        this.swalBox("warning", "Fiş bulunamadı", "Bu talep için fiş URL'si dönmedi.", false);
        return;
      }
      this.receiptImageError = false;
      this.receiptRetried = false;
      this.receiptRequestId = requestId || null;
      this.receiptUrl = fileUrl;
      this.$modal.show("receipt-modal");
    },
    onReceiptImageError() {
      // URL süresi dolmuş olabilir → bir kez getAll çağırıp taze URL al
      if (this.receiptRetried || !this.receiptRequestId) {
        this.receiptImageError = true;
        return;
      }
      this.receiptRetried = true;
      this.getAll().then(() => {
        const updated = this.List.find((r) => r.id === this.receiptRequestId);
        if (updated && updated.receiptFileUrl && updated.receiptFileUrl !== this.receiptUrl) {
          // Cache'i bypass etmek için cache-busting parametresi ekle
          this.receiptUrl = updated.receiptFileUrl;
          this.receiptImageError = false;
        } else {
          this.receiptImageError = true;
        }
      }).catch(() => { this.receiptImageError = true; });
    },
    closeReceiptModal() {
      this.$modal.hide("receipt-modal");
      this.receiptUrl = "";
      this.receiptImageError = false;
      this.receiptRetried = false;
      this.receiptRequestId = null;
    },
    showDetail(item) {
      this.detailItem = item;
      this.$modal.show("request-detail-modal");
    },
    correctOcr(payload) {
      axios.post(fuel.requestOcrCorrect, payload, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          this.swalBox("success", "Fiş Değerleri Güncellendi", "Siber'e bu değerler gönderilecek.", false);
          return this.getAll();
        })
        .then(() => this.refreshDetail(payload.requestId))
        .catch((err) => { this.handleApiError(err); });
    },
    openEditModal(item) {
      // İşlem modalinin icinden cagriliyor; modallar ust uste binmesin.
      this.$modal.hide("request-detail-modal");
      this.editItem = item;
      // İstasyon listesini önceden yükle
      if (this.allStations.length === 0) {
        axios.get(fuel.stationGetAllNotPagination, {
          headers: { Authorization: "Bareer " + this.$store.state.userData.token },
        })
          .then((res) => { this.allStations = res.data.data || []; })
          .catch(() => {});
      }
      this.$modal.show("edit-request-modal");
    },
    openCancelModal(item) {
      this.$modal.hide("request-detail-modal");
      this.cancelItem = item;
      this.$modal.show("cancel-request-modal");
    },
    removeFromList(id) {
      // İptal edilen talebi aktif listeden anında kaldır (optimistic UI)
      this.List = this.List.filter(r => r.id !== id);
      this.totalCount = Math.max(0, this.totalCount - 1);
    },
    // === SSE EVENT HANDLERS ===
    setupSseListeners() {
      this.clearSseListeners();
      // new-request: yeni talep oluştu
      this.sseUnsubs.push(
        fuelStream.on("new-request", (e) => this.onSseChange(e, true))
      );
      // request-updated: onay/yönlendirme/markFueled/edit
      this.sseUnsubs.push(
        fuelStream.on("request-updated", (e) => this.onSseChange(e, false))
      );
      // request-completed → status 6 (aktif sekmeden çıkar)
      this.sseUnsubs.push(
        fuelStream.on("request-completed", (e) => this.onSseChange(e, false))
      );
      // request-cancelled → status 7 (aktif sekmeden çıkar)
      this.sseUnsubs.push(
        fuelStream.on("request-cancelled", (e) => this.onSseChange(e, false))
      );
      // Kalem event'leri: ilgili talebin items'ını yenilemek için
      ["item-added", "item-approved", "item-rejected"].forEach((type) => {
        this.sseUnsubs.push(
          fuelStream.on(type, (e) => this.onSseItemChange(e))
        );
      });
      // Bağlantı durumu izle
      this.sseUnsubs.push(
        fuelStream.onStatus((status) => { this.sseStatus = status; })
      );
    },
    clearSseListeners() {
      this.sseUnsubs.forEach((fn) => { try { fn(); } catch (e) { /* noop */ } });
      this.sseUnsubs = [];
    },
    onSseChange(event, isNew) {
      const reqId = event.requestId;
      if (!reqId) return;
      // İlgili talebi fetch et — payload'ta yeterli alan yoksa getAll re-fetch en güvenlisi
      this.fetchSingleRequest(reqId, isNew);
    },
    onSseItemChange(event) {
      const reqId = event.requestId;
      if (!reqId) return;
      this.fetchSingleRequest(reqId, false);
    },
    fetchSingleRequest(reqId, isNew) {
      // Polling yerine: tek talebi getirmek için getAll'u tetikleme, çünkü tek-talep endpoint'i yok
      // Pragmatik çözüm: aktif sayfa için getAll çağır
      this.getAll().then(() => {
        // SSE event sonrası ilgili satırı bul, flash efekti uygula
        const idx = this.List.findIndex((r) => r.id === reqId);
        if (idx >= 0) {
          this.$set(this.List, idx, { ...this.List[idx], _flash: true });
          setTimeout(() => {
            const i = this.List.findIndex((r) => r.id === reqId);
            if (i >= 0) this.$set(this.List, i, { ...this.List[i], _flash: false });
          }, 2000);
        }
        // Detay modal açıksa onu da yenile
        if (this.detailItem && this.detailItem.id === reqId) {
          this.refreshDetail(reqId);
        }
      });
    },
  },
  created() {
    this.getAll();
  },
  mounted() {
    this.setupSseListeners();
    // Sayfa bildirimden açıldıysa ilgili talebin detayını aç
    this.checkPendingNotificationOpen();
    // Aynı sayfadayken bildirim tıklanırsa
    this._notifHandler = (e) => {
      const reqId = e?.detail?.requestId;
      if (reqId) this.openDetailById(reqId);
    };
    window.addEventListener("openFuelRequestDetail", this._notifHandler);
  },
  beforeDestroy() {
    this.clearSseListeners();
    if (this._notifHandler) window.removeEventListener("openFuelRequestDetail", this._notifHandler);
  },
  watch: {
    currentPage() { this.getAll(); },
  },
};
</script>
